import React from "react";
import { Form } from "react-bootstrap";

const SelectFlag = ({ formik, field }) => (
  <>
    <Form.Control
      as="select"
      id={field}
      name={field}
      disabled={formik.isSubmitting}
      value={formik.values[field]}
      onChange={formik.handleChange}
      isInvalid={formik.touched[field] && formik.errors[field]}
    >
      <option key="0" value="">
        Selecione
      </option>
      <option key="N" value="N">
        Não
      </option>
      <option key="S" value="S">
        Sim
      </option>
    </Form.Control>
    {formik.touched[field] && formik.errors[field] && (
      <Form.Control.Feedback type="invalid">{formik.errors[field]}</Form.Control.Feedback>
    )}
  </>
);

export default SelectFlag;
